import React from 'react';
/* eslint react/prop-types: 0 */
import styles from './nav.css';

const Nav = (props) => {
  const dots = [];
  for (let i = 1; i <= props.totalSteps; i += 1) {
    const isActive = props.currentStep === i;
    dots.push((
        <span
            key={`step-${i}`}
            className={`webrtc-wizard-dot ${isActive ? 'webrtc-wizard-active' : ''}`}
            onClick={() => props.goToStep(i)}
        >&bull;</span>
    ));
  }

  return (
      <div className="webrtc-wizard-nav">{dots}</div>
  );
};

export default Nav;
